import React from 'react';
import ReactApexChart from 'react-apexcharts';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { Company } from '../../models/company.model';
import { monthValue } from '../../libraries/month.library';
import { formatCurrency } from '../../scripts/format.value.script';

export interface AppChartBarSalesPurchasesProps {
  id: string,
  companyForUser: Company,
  info: {month: string, total_sales: number, total_purchases: number}[]
};

const AppChartBarSalesPurchases: React.FunctionComponent<AppChartBarSalesPurchasesProps> = ({id, companyForUser, info}) => {
  const {lang} = StateLanguage()

  const safeInfo = info ?? []

  const state = {
    series: [{
      name: lang.labels.amountSales,
      data: safeInfo.map((item) => {
        return item.total_sales ?? 0
      })
    }, {
      name: lang.labels.amountPurchases,
      data: safeInfo.map((item) => {
        return item.total_purchases ?? 0
      })
    }],
    options: {
      chart: {
        id: "bar",
        height: 350,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "85%",
          endingShape: "rounded"
        },
      },
      colors: ["#50CD89", "#F1416C"],
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['transparent']
      },
      xaxis: {
        categories: safeInfo.map((item) => {
          return monthValue(lang, item.month).toUpperCase()
        }),
      },
      yaxis: {
        title: {
          text: '' /* formatCurrency(companyForUser.currency) */
        }
      },
      fill: {
        opacity: 1
      }
    }
  }

  return (
    <div id={id}>
      <ReactApexChart options={state.options} series={state.series} type="bar" height={400} />
    </div>
  )
};

export default AppChartBarSalesPurchases;
